var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009447;}.cls-1,.cls-2{opacity:0.75;}.cls-2{fill:#006838;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1738.4,1000c0,407.81-330.59,738.4-738.4,738.4-203.27,0-387.35-82.13-520.87-215l183.11-183.1A477.92,477.92,0,0,0,1000,1479.45c264.79,0,479.45-214.66,479.45-479.45a477.92,477.92,0,0,0-139.18-337.76l183.1-183.11C1656.27,612.65,1738.4,796.73,1738.4,1000Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1523.37,479.13l-183.1,183.11A478,478,0,0,0,1000,520.55c-264.79,0-479.45,214.66-479.45,479.45a478,478,0,0,0,141.69,340.27l-183.11,183.1C344.76,1389.66,261.6,1204.54,261.6,1000c0-407.81,330.59-738.4,738.4-738.4C1204.54,261.6,1389.66,344.76,1523.37,479.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight);
export default __webpack_public_path__ + "static/media/icon_light.b65eb03c77a0fb5c7867c1521bfa8684.svg";
export { ForwardRef as ReactComponent };